module.exports = __webpack_public_path__ + "img/1-m.4b5cba08.jpg";